<p>
  deletelead works!
</p>



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/lead/deletelead/deletelead.component.html